// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lSUU","label":"styles_label__ROi6T"};